import {settings} from 'constants/url';
import {OnlyTwoParamsOptions} from '../../../components/grid-dx/types';
import useAddOnlyTwoParamsOptions from './useAddOnlyTwoParamsOptions';

function useAddParameter() {
  const addParameter = useAddOnlyTwoParamsOptions(settings);
  return (onlyTwoParamsOptions: OnlyTwoParamsOptions) =>
    addParameter(onlyTwoParamsOptions);
}

export default useAddParameter;
